import * as React from "react";
import { useContext } from "react";
import BaseCard from "../Cards/Card";
import { LeftSideBoldSpan, LeftSideRightSpan } from "../Cards/LeftSideStyle";
import { PdsrClientViewModel } from "../../../ViewModel/PdsrClientViewModel";
import { EditProjectContext } from "../../EditProjectContext";
import { RouteEditTab } from "../../RouteEditTab";
import { PdsrDelete } from "./PdsrDelete";
import { isSelected } from "../InboundTab/IsSelected";
import { isFinished } from "../InboundTab/IsFinished";
import { getIdOfSpdrOrPdsr } from "../../RightSide/LtlTab/GetIdOfSpdrOrPdsr";
import { CardDeletionProps } from "../Cards/CardDeletionProps";
import { ReadOnlyProps } from "../../ReadOnlyProps";
import { isRouteTabFtlAndProjectInSandbox } from "../isRouteTabFtlAndProjectInSandbox";

export type PdsrCardProps = {
  readonly pdsr: PdsrClientViewModel;
};

export const PdsrCard = ({
  pdsr,
  deletionAllowed,
  setDeletionAllowed,
  isReadOnly,
}: PdsrCardProps & CardDeletionProps & ReadOnlyProps) => {
  const { ContainerNetwork, SupplierGsdb, PlantGsdb, DockCode, UsedInFtlRoutes } = pdsr;

  const { project, routeEditTabSelected, selectedLtlSpdrOrPdsr, setSelectedLtlSpdrOrPdsr } =
    useContext(EditProjectContext);

  const handleClick = () => {
    switch (routeEditTabSelected) {
      case RouteEditTab.Ftl:
        return;
      case RouteEditTab.Ltl:
        handleLtlClick();
        return;
      default:
        throw new Error(`PdsrCard handleLtlClick not implemented for ${routeEditTabSelected}`);
    }
  };

  const handleLtlClick = () => {
    setSelectedLtlSpdrOrPdsr(pdsr);
  };

  const $hasDeleteButton =
    isRouteTabFtlAndProjectInSandbox({
      selectedRouteTab: routeEditTabSelected,
      projectState: project.State,
    }) && !isReadOnly;
  const $isFinished = isFinished(project, pdsr?.PdsrId);
  const $isSelectable = routeEditTabSelected === RouteEditTab.Ltl;
  let selectedPdsrId = getIdOfSpdrOrPdsr(selectedLtlSpdrOrPdsr);
  if (selectedLtlSpdrOrPdsr && "PdsrId" in selectedLtlSpdrOrPdsr && selectedLtlSpdrOrPdsr?.PdsrId) {
    selectedPdsrId = selectedLtlSpdrOrPdsr.PdsrId;
  }

  return (
    <BaseCard
      onClick={() => handleClick()}
      $isSelected={isSelected(routeEditTabSelected, selectedPdsrId, pdsr?.PdsrId)}
      $isFinished={$isFinished}
      $hasDeleteButton={$hasDeleteButton}
      $isSelectable={$isSelectable}
    >
      <LeftSideBoldSpan>
        {ContainerNetwork} - {PlantGsdb} - {DockCode} - {SupplierGsdb}
      </LeftSideBoldSpan>
      <LeftSideRightSpan>{UsedInFtlRoutes}</LeftSideRightSpan>
      <PdsrDelete
        pdsr={pdsr}
        noDeletionProcessCurrentlyRunning={deletionAllowed}
        setNoDeletionProcessCurrentlyRunning={setDeletionAllowed}
        disabled={isReadOnly}
      />
    </BaseCard>
  );
};
